module.exports = __webpack_public_path__ + "img/shield.04cd8f07.svg";